import { Controller } from 'stimulus';

export default class extends Controller {
  
  connect() {
    this.resetAlert();
  }

  resetAlert() {
    $("#alert").text('');
    $("#alert").removeClass("alert-danger");
    $("#alert").removeClass("alert-success");
  }

  sendCodeRequestHandler(event) {
    event.preventDefault();
    var state = this;
    var id = this.getIDFromURL();
    var obj = {
      phone: $("#phone").val()
    }
    state.showLoader(event);
    state.resetAlert();
    if(id !== false) {
      obj["id"] = id;
    }
    $.ajax({
      url: "/telegram_accounts/initiate_session",
      method: "POST",
      data: obj,
      dataType: 'json',
      success: (result, status, jqXHR) => {
        if(result['success'] == false) {
          $("#alert").text(result['msg']);
          $("#alert").addClass("alert-danger");
        } else {
          $("#alert").text(result['msg']);
          $("#alert").addClass("alert-success");
          $("#send_code_request").addClass('d-none');
          $("#sign_in").removeClass('d-none');
        }
        this.hideLoader(event);
      },
      error: (jqXHR, textStatus, errorThrown) => {
        $("#alert").text('Something went wrong please try again!!!');
        $("#alert").addClass("alert-danger");
        this.hideLoader(event);
      }
    });
  }

  signInHandler(event) {
    event.preventDefault();
    this.showLoader(event);
    this.resetAlert();
    var obj = {
      phone: $("#phone").val(),
      code: $("#code").val()
    }
    $.ajax({
      url: "/telegram_accounts/create_session",
      method: "POST",
      data: obj,
      success: (result, status, jqXHR) => {
        console.log(result)
        if(result['success'] == false) {
          this.hideLoader(event);
          $("#alert").text(result['msg']);
          $("#alert").addClass("alert-danger");
        } else {
          window.location.href = "/telegram_accounts"
        }

      },
      error: (jqXHR, textStatus, errorThrown) => {
        this.hideLoader(event);
        $("#alert").text('Something went wrong please try again!!!');
        $("#alert").addClass("alert-danger");
      }
    });
  }

  getIDFromURL() {
    var checkIfEdit = window.location.href.match(/\/telegram_accounts\/[0-9]+\/edit$/gm);
    if (checkIfEdit != null) {
      return checkIfEdit[0].match(/[0-9]+/g)[0]
    }
    return false;
  }

  storeCredentials(obj) {
    var method = "POST";
    var id = this.getIDFromURL();
    var url = "/telegram_accounts";
    if (id !== false) {
      method = "PUT";
      obj["id"] = id;
      url += "/" + id
    }
    $.ajax({
      url:url, 
      method: method,
      data: obj,
      success: (result, status, jqXHR) => {
        window.location.href = "/telegram_accounts";
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(textStatus);
      }
    });
  }

  showLoader(event) {
    var $this = $(event.target);
    console.log($this.html())
    $this.html('<i class="fa fa-circle-o-notch fa-spin"></i>');
    $this.addClass('disabled');
  }

  hideLoader(event) {
    var $this = $(event.target);
    $this.html('Submit');
    $this.removeClass('disabled');
  }
  
}